import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Calendar, BarChart3, Globe } from "lucide-react";
import PlanningUnifiePage from "./PlanningUnifiePage";
import SynthesePlanningsPage from "./SynthesePlanningsPage";
import PlanningGlobalPage from "./PlanningGlobalPage";

export default function PlanningPage() {
  const [tab, setTab] = useState("gestion");
  return (
    <div className="space-y-4">
      <Tabs value={tab} onValueChange={setTab} className="space-y-4">
        <TabsList>
          <TabsTrigger value="gestion" className="gap-2"><Calendar className="w-4 h-4" />Gestion</TabsTrigger>
          <TabsTrigger value="synthese" className="gap-2"><BarChart3 className="w-4 h-4" />Synthese</TabsTrigger>
          <TabsTrigger value="globale" className="gap-2"><Globe className="w-4 h-4" />Vue globale</TabsTrigger>
        </TabsList>
        <TabsContent value="gestion"><PlanningUnifiePage /></TabsContent>
        <TabsContent value="synthese"><SynthesePlanningsPage /></TabsContent>
        <TabsContent value="globale"><PlanningGlobalPage /></TabsContent>
      </Tabs>
    </div>
  );
}
